import axios from 'axios';

const API = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:5000/api',
  timeout: 15000,
});

// Token automatically attach karo
API.interceptors.request.use((config) => {
  const token = localStorage.getItem('bhamsa_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// 401 pe logout karo
API.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem('bhamsa_token');
      localStorage.removeItem('bhamsa_user');
      window.location.href = '/login';
    }
    return Promise.reject(err);
  }
);

// Auth
export const authAPI = {
  login:          (data) => API.post('/auth/login', data),
  getMe:          ()     => API.get('/auth/me'),
  updateProfile:  (data) => API.put('/auth/profile', data),
  changePassword: (data) => API.put('/auth/change-password', data),
  changePhone:    (data) => API.put('/auth/change-phone', data),
  uploadLogo:     (data) => API.post('/auth/upload-logo', data, {
    headers: { 'Content-Type': 'multipart/form-data' }
  }),
  uploadUpiQr:    (data) => API.post('/auth/upload-upi', data, {
    headers: { 'Content-Type': 'multipart/form-data' }
  }),
};

// Products
export const productAPI = {
  getAll:       (params) => API.get('/products', { params }),
  getOne:       (id)     => API.get(`/products/${id}`),
  create:       (data)   => API.post('/products', data, {
    headers: { 'Content-Type': 'multipart/form-data' }
  }),
  update:       (id, data) => API.put(`/products/${id}`, data, {
    headers: { 'Content-Type': 'multipart/form-data' }
  }),
  delete:       (id)     => API.delete(`/products/${id}`),
  getCategories: ()      => API.get('/products/categories'),
};

// Customers
export const customerAPI = {
  getAll:  (params)   => API.get('/customers', { params }),
  getOne:  (id)       => API.get(`/customers/${id}`),
  create:  (data)     => API.post('/customers', data),
  update:  (id, data) => API.put(`/customers/${id}`, data),
  delete:  (id)       => API.delete(`/customers/${id}`),
};

// Invoices
export const invoiceAPI = {
  getAll:      ()     => API.get('/invoices'),
  create:      (data) => API.post('/invoices', data),
  downloadPDF: (id)   => API.get(`/invoices/${id}/download-pdf`, { 
    responseType: 'blob' 
  }),
};

// Reports
export const reportAPI = {
  getDashboard:  () => API.get('/reports/dashboard'),
  getSales:      (period) => API.get('/reports/sales', { params: { period } }),
  getStock:      () => API.get('/reports/stock'),
  getTopProducts: () => API.get('/reports/top-products'),
};

// Notifications
export const notificationAPI = {
  getAll:  () => API.get('/notifications'),
  markRead: (id) => API.put(`/notifications/${id}/read`),
  markAllRead: () => API.put('/notifications/read-all'),
};
// Payments
export const paymentAPI = {
  getAll:       (status) => API.get('/payments', { params: { status } }),
  updateStatus: (id, status) => API.put(`/payments/${id}/status`, { payment_status: status }),
};
// Export
export const exportAPI = {
  salesExcel: (period) => API.get('/export/sales', { 
    params: { period }, 
    responseType: 'blob' 
  }),
};
// Staff
export const staffAPI = {
  getAll:           ()         => API.get('/staff'),
  create:           (data)     => API.post('/staff', data, { headers: { 'Content-Type': 'multipart/form-data' } }),
  update:           (id, data) => API.put('/staff/' + id, data, { headers: { 'Content-Type': 'multipart/form-data' } }),
  delete:           (id)       => API.delete('/staff/' + id),
  markAttendance:   (data)     => API.post('/staff/attendance', data),
  getAttendance:    (id, month, year) => API.get('/staff/attendance/' + id, { params: { month, year } }),
  getTodayAttendance: ()       => API.get('/staff/attendance-today'),
};
// Damaged Stock
export const damagedAPI = {
  report:  (data) => API.post('/damaged', data),
  getHistory: (params) => API.get('/damaged/history', { params }),
};
// Offline Sales
export const offlineSaleAPI = {
  create:   (data)   => API.post('/offline-sales', data),
  getAll:   (params) => API.get('/offline-sales', { params }),
  getStats: ()       => API.get('/offline-sales/stats'),
};

export default API;